import React, { useState,useMemo, forwardRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Card_link.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  InputGroup
} from 'react-bootstrap';
import { get_all_cards } from '../../../../utils/talent_services';


const Card_link = forwardRef(({ user_id, permission, onSet, token_num, initialRows: initialRowsProp }) => {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'title', dir: 'asc' });
    const [fetchedRows, setFetchedRows] = useState([ ]);
   
    // Si se reciben tarjetas desde el padre (ej. App.js vía get_current_cards), usarlas; si no, cargar con get_all_cards
    const initialRows = Array.isArray(initialRowsProp) ? initialRowsProp : fetchedRows;

    useEffect(() => {
       if (initialRowsProp === undefined) {
          fetchloadStrategies(token_num);
       }
    }, []); 

    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = initialRows;
  
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }
  
      result = [...result].sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
  
        if (aVal === bVal) return 0;
        const order = aVal > bVal ? 1 : -1;
        return sortConfig.dir === 'asc' ? order : -order;
      });
  
      return result;
    }, [searchTerm, sortConfig, initialRows]);
  
    // --- Handlers ---
    const toggleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
        }
        return { key, dir: 'asc' };
      });
    };

    const add_linked_strategy = (id, title, shortURL, desc, kr_trello_id) => {
      onSet(id, title, shortURL ?? null, desc ?? null, kr_trello_id ?? null);
    };

    
    async function fetchloadStrategies(token) {
          const usrData = await get_all_cards(token);
          if (usrData==="INVALID"){
              navigate("/");
          }
          else{
            const tempCard = usrData.map((celement, index) => {
              return {
                id: celement.id,
                trello_card_id: celement.trello_card_id,
                title: celement.title,
                shortURL: celement.shortURL,
                index:index
              };
            });
            setFetchedRows(tempCard);
            
          }
    }
 
  
    // Icono flecha ↑↓
    const SortIcon = ({ col }) =>
      sortConfig.key === col ? (sortConfig.dir === 'asc' ? '↑' : '↓') : '↕';
  

    // ---------- UI ----------
    return (
      <div className="container py-4">

        {/* Barra de búsqueda + menús */}
        <div className="d-flex gap-2 mb-3 flex-wrap">
          <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
            <Form.Control
              placeholder="Search strategy..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control'
            />
          </InputGroup>
        </div>

        {/* Tabla */}
        <div style={{ height: '400px', overflowY: 'auto' }}> {/* Altura fija y scroll */}
          {/* Añade la clase text-start aquí */}
          <Table hover responsive className="align-middle text-start">
            <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
              <tr >
                  <th onClick={() => toggleSort('title')} role="button">
                    Strategies <SortIcon col="channelName" />
                  </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} onClick={() => add_linked_strategy(row.trello_card_id, row.title, row.shortURL, row.desc, row.kr_trello_id)} >
                  <td>{row.title}</td>
                </tr>

              ))}
              {rows.length === 0 && (
                <tr>
                  {/* También puedes añadir text-start aquí si quieres asegurar la alineación para el mensaje "No results" */}
                  <td colSpan="10" className="text-center py-4 text-start">
                    No results
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    );
});

export default Card_link;
